<template>
  <div class='home'>
    <CompanyList v-show='listView' @newCompany='onClickNewFromList' @editCompany='onClickEditFromList' :scroll="corY" ref='refreshList' />
    <CompanyForm v-show='formView' :company='company' @backClicked='onBackChild'/>
  </div>
</template>

<script>
// @ is an alias to /src
import CompanyList from '@/components/company/CompanyList.vue'
import CompanyForm from '@/components/company/CompanyForm.vue'

export default {
  name: 'Company',
  components: {
    CompanyList,
    CompanyForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      company: {
        id: null,
        company_no: null,
        name: null,
        address: null,
        phone: null,
        npwp: null,
        email: null,
        alias: null,
        is_tax: false,
        taX_id: null,
        accounts: [{
          id: null,
          alias: null,
          company_no: null,
          bank_id: null,
          bank_account: null,
          bank_address: null,
          bank_account_name: null,
          notes: null,
          billing_no: null,
          type: null
        }],
        photos: [{
          id: null,
          company_no: null,
          tag: null,
          filename: null,
          mime_type: null,
          extension: null,
          url: null
        }],
        settings: [{
          id: null,
          name: null,
          active: false,
          description: null,
          ref_no: null,
          company_no: null
        }]
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.company = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.company = {
        id: null,
        company_no: null,
        name: null,
        address: null,
        phone: null,
        npwp: null,
        email: null,
        alias: null,
        is_tax: false,
        taX_id: null,
        accounts: [{
          id: null,
          alias: null,
          company_no: null,
          bank_id: null,
          bank_account: null,
          bank_address: null,
          bank_account_name: null,
          notes: null,
          billing_no: null,
          type: null
        }],
        photos: [{
          id: null,
          company_no: null,
          tag: null,
          filename: null,
          mime_type: null,
          extension: null,
          url: null
        }],
        settings: [{
          id: null,
          name: null,
          active: false,
          description: null,
          ref_no: null,
          company_no: null
        }]
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.company = {
        id: null,
        company_no: null,
        name: null,
        address: null,
        phone: null,
        npwp: null,
        email: null,
        alias: null,
        is_tax: false,
        taX_id: null,
        accounts: [{
          id: null,
          alias: null,
          company_no: null,
          bank_id: null,
          bank_account: null,
          bank_address: null,
          bank_account_name: null,
          notes: null,
          billing_no: null,
          type: null
        }],
        photos: [{
          id: null,
          company_no: null,
          tag: null,
          filename: null,
          mime_type: null,
          extension: null,
          url: null
        }],
        settings: [{
          id: null,
          name: null,
          active: false,
          description: null,
          ref_no: null,
          company_no: null
        }]
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getBankList')
    this.$store.dispatch('getTaxList')
  }
}
</script>
